import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch("/data/blogs.json")
      .then((res) => res.json())
      .then((data) => setBlogs(data))
      .catch((err) => console.error("Error loading blogs:", err));
  }, []);

  return (
    <section className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            English Learning Blog
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Expert-written articles to help you improve your spoken English,
            pronunciation, and fluency — one day at a time.
          </p>
        </div>

        {/* Blog Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {blogs.map((blog, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-lg overflow-hidden 
                         transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl"
            >
              {/* Image Section */}
              <div className="relative">
                <img
                  src={blog.headerImage}
                  alt={blog.title}
                  className="w-full h-48 object-cover transition duration-500 hover:scale-105"
                />
                <span className="absolute top-3 left-3 bg-green-500 text-white text-sm font-medium px-3 py-1 rounded-full shadow-md">
                  New
                </span>
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 to-transparent" />
              </div>

              {/* Text Section */}
              <div className="p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2">
                  {blog.title}
                </h2>
                <p className="text-gray-600 text-sm line-clamp-3 mb-4">
                  {blog.metaDescription}
                </p>

                <Link
                  to={`/blogs/${blog.slug}`}
                  className="inline-block bg-indigo-600 text-white font-medium px-5 py-2 rounded-xl hover:bg-indigo-700 transition"
                >
                  Read More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogList;
